import React from "react";
import { FaFacebookF, FaLinkedinIn } from "react-icons/fa";
import { FiGithub } from "react-icons/fi";
import { BsInstagram, BsWhatsapp } from "react-icons/bs";

const AboutUs = () => {
  return (
    <div className="about-us section-padding">
      <div className="container">
        <div className="row">
          <div
            className="col-xl-6 offset-xl-3 col-lg-10 offset-lg-1"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="section-title-center text-center">
              <span>ABOUT ME</span>
              <h2 className="display-6">Some core information's about me</h2>
              <div className="section-divider divider-traingle"></div>
            </div>
          </div>
        </div>
        <div className="row gx-5">
          <div
            className="col-lg-6 mb-3 mb-lg-0"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="200"
          >
            <div className="about-us__image">
              <img
                className="img-fluid"
                src="assets/images/about.jpg"
                alt="About us"
              />
            </div>
          </div>
          <div
            className="col-lg-6"
            data-aos="fade-up"
            data-aos-duration="1000"
            data-aos-delay="100"
          >
            <div className="about-us__content">
              <h3 className="display-6">Hello, I'm Sakhawat Hossain</h3>
              <p className="about-us__content__text">
                I'm an enthusiastic web developer with a strong passion for
                JavaScript. My goal is to thrive in Bangladesh's software
                industry by collaborating with local and multinational IT
                agencies. I'm well-versed in an array of modern web
                technologies, including PHP, JavaScript (ES6), OOP, Node.js, WordPress, Elementor customization, React.js, Next.js, Redux, React Router, Stripe.js, Bootstrap, Tailwind CSS, Material UI, HTML5, CSS3, Sass, Firebase, MongoDB,
                Mongoose, Express.js, Strapi, TypeScript, Vercel, Netlify, Render, and Heroku. My expertise lies in crafting dynamic and appealing web solutions that leverage the power of these tools.
              </p>
              <p>
                I want to be a Professional Full Stack Developer, it's my dream.
                I love to learn new tech and new languages.
              </p>
              <h3 className="mt-4">My Social Media Accounts.</h3>
              <ul className="social-icon mt-3">
                <li>
                  <a href="https://facebook.com/shshakib2001/">
                    <FaFacebookF />
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/shshakib2001">
                    <BsInstagram />
                  </a>
                </li>
                <li>
                  <a href="tel:01849687969">
                    <BsWhatsapp />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/in/shjsdev/">
                    <FaLinkedinIn />
                  </a>
                </li>
                <li>
                  <a href="https://github.com/sakhawat9">
                    <FiGithub />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutUs;
